import {
  createContext,
  useContext,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react"

interface LeadsListsContextType {
  leadsLists: { id: number; name: string }[]
  setLeadsLists: Dispatch<SetStateAction<{ id: number; name: string }[]>>
}

const LeadsListsContext = createContext<LeadsListsContextType | undefined>(
  undefined,
)

export const LeadsListsProvider = ({
  initialLeadsLists,
  children,
}: {
  initialLeadsLists: { id: number; name: string }[]
  children: React.ReactNode
}) => {
  const [leadsLists, setLeadsLists] = useState(initialLeadsLists)

  return (
    <LeadsListsContext.Provider value={{ leadsLists, setLeadsLists }}>
      {children}
    </LeadsListsContext.Provider>
  )
}

export const useLeadsLists = () => {
  const context = useContext(LeadsListsContext)
  if (context === undefined) {
    throw new Error("useLeadsLists must be used within a LeadsListsProvider")
  }
  return context
}
